export default {
  AddToHomeScreen: 'Add To Home Screen',
  notFound: 'User not found',
  loginFailed: 'Wrong username or password.',
  invalidPassword: 'Invalid password',
  emailNotFound: 'Email not found',
  userNotFound: 'User not found',
  invalidToken: 'Invalid token',
  phoneNumberNotVerified: 'Your phone number has not been verified',
  emailNotVerified: 'Your email has not been verified',
  ChangePassword: 'Change Password',
  Login: 'Login',
  Logout: 'Logout',
  Register: 'Register',
  SignInToYourAccount: 'Sign in to your account',
  Email: 'Email',
  Username: 'Username',
  Password: 'Password',
  HaveYouForgotPassword: 'Forgot Password?',
  RememberPassword: 'Remember password',
  ForgotPassword: 'Forgot password',
  ResetPassword: 'Reset password',
  Account: 'Account',
  Profile: 'Profile',
  SignUp: 'Sign up',
  EnterEmail: 'Please enter your email',
  EnterNewPassword: 'Please enter new password',
  ResetPasswordEmailSentTo: 'Reset password email sent to "{email}".',
  PleaseCheckYourInbox: 'Please check your inbox.',
  AndMaybeYourSpamFolder: 'And maybe your spam folder!',
  SignUpMessage: 'Not registered yet? Click on button bellow.',
  RegisterNow: 'Register Now!',
  CurrentPassword: 'Current Password',
  NewPassword: 'New Password',
  ConfirmPassword: 'Confirm Password',
  RepeatPassword: 'RepeatPassword',
  NewPasswordAndConfirmDontMatch: "New password and confirm don't match",
  NationalId: 'کد ملی',
  YourPasswordHasChanged: 'Your password has changed',
  UseSocialToLogin: 'Use {provider} to login',
  google: 'Google',
  facebook: 'Facebook',
  CreateAccount: 'Create Account',
  CreateYourAccount: 'Create Your Account',
  UseYourSocialAcountToRegister: 'Use your social acount to register.',
  UsernameAlreadyTaken:
    'This username is already taken. please choose another one.',
  RegisterSuccessful: 'You registered successfully.',
  PasswordAndItsRepeatDoesntMatch: 'Password and its repeat does not match.',

  // refactored
  loginRegister: 'Login | Register',
  login: 'Login',
  register: 'Register',
  loginWithPassword: 'Login with password',
  otpLogin: 'Login via one-time password',
  twoStepVerification: 'Two step verification',
  loginDescription_html: 'Hi!<br/>Please enter your mobile number',
  pleaseEnterYourPassword: 'Please enter your password',
  forgotPassword: 'Forgot password',
  userIsNotAdmin: 'Only admins can login',
  otpLoginTemplate_html:
    'Verification code sended to <b>{mobile}</b>.<br/>Please enter verification code',
  verificationCode: 'Verification code',
  otpCountdownTemplate: '{minutes}:{seconds} remains to re-send code',
  resendOtpCode: 'Resend verification code',
  password: 'Password',
  noUserFoundWithThisMobile: 'No user found with this mobile',
  forgotPasswordDescription: 'To change password, enter your mobile number',
  resetPassword: 'Reset password',
  newPassword: 'New password',
  newPassword2: 'Repeat new password'
}
